import { StyleSheet } from 'react-native';
import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    flexDirection: 'column',
    paddingVertical: 6,
  },
  topRow: {
    paddingBottom: 3,
  },
  bottomRow: {
    paddingTop: 3,
  },
  topRowDisabled: {
    color: PALETTE.primaryTextDisabled,
  },
});
